import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { AccordionActions } from "@mui/material";
import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
} from "../../Default/LekUI/Accordion";
import Hint from "../Default/Hint";

function Filter(props) {
	return (
		<div className={props.className}>
			<Accordion
				expanded={!props.disabled && props.expanded}
				onChange={props.onChange}
				disabled={props.disabled}
				className={props.accordionClassName}
			>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon />}
					aria-controls="panel1bh-content"
					className={props.accordionSummaryClassName}
				>
					<div className="p-relative flex items-center gap-8">
						{!!props.selected && <div className="primary-dot" />}
						<span className="size-16-light">{props.title}</span>
						{props.actions && (
							<AccordionActions
								className="p-0"
								onClick={(e) => e.stopPropagation()}
							>
								<span>{props.actions}</span>
							</AccordionActions>
						)}
						{props.hint && <Hint hint={props.hint} />}
					</div>
				</AccordionSummary>
				<AccordionDetails className={props.accordionDetailsClassName}>
					{props.expanded && props.renderFilterDetails()}
				</AccordionDetails>
			</Accordion>
		</div>
	);
}

export default Filter;
